import { useEffect, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getTransactionSerialNumbers } from 'src/api/stoApi';
import { generalStore } from 'src/stores/GeneralStore';

export const useSerialNumbers = ({ assetId, transactionId }: { assetId: string; transactionId: string }) => {
  const [serialNumbers, setSerialNumbers] = useState<{ serialNumber: string }[]>([]);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        if (!transactionId) {
          return;
        }
        const response = await getTransactionSerialNumbers({ assetId, transactionId });
        console.log({ result: response.data.data, assetId, transactionId });
        setSerialNumbers(response.data.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    load();
  }, [transactionId]);

  return serialNumbers;
};
